








































import router from "@/router/router";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { Vue, Component } from "vue-property-decorator";
import { GenericDevice } from "@/data/models/GenericDevice";
import { getGenericDeviceDetails } from "@/data/repository/GenericDeviceRepository";
import { GenericDeviceProjectAssignment } from "@/data/models/GenericDeviceAssignment";
import { getDeviceAssignmentsByDeviceId } from "@/data/repository/GenericDeviceAssignmentRepository";
import GenericDeviceHistoryItem from "./GenericDeviceHistoryItem.vue";
import { timestampToDate } from "@/utils/DateFormatter";
import { calculateBackgroundStyle, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";

@Component({
  name: "DeviceHistoryComponent",
  components: {
    "device-history-item": GenericDeviceHistoryItem
  },
})
export default class DeviceHistoryComponent extends Vue {
  isLoading = false;
  genericDevice: GenericDevice | null = null;

  isShowing = false;

  deviceAssignments: GenericDeviceProjectAssignment[] = [];

  showNoHistoryHint = false;
  highligtedIndex: number | null = null;

  forceUpdateBackgroundColor = false;

  getItemNumber(index: number) {
    return this.deviceAssignments.length - index;
  }

  onHighlightEndValue(index: number) {
    this.highligtedIndex = index;
  }

  onOpenProjectDetails(projectId: string) {
    this.forceUpdateBackgroundColor = !this.forceUpdateBackgroundColor;

    router.push({
      path: `/main/projects/${projectId}`,
      params: {
        projectId: projectId,
      },
    });
  }

  async created() {
    this.isLoading = true;
    const deviceId = router.currentRoute.query["deviceId"] as string;

    this.genericDevice = await getGenericDeviceDetails(deviceId);

    ToolbarContentModule.setToolbarTitle(this.title);

    const deviceAssignments = await getDeviceAssignmentsByDeviceId(this.genericDevice.id);
    this.deviceAssignments = deviceAssignments
      .filter((assignment) => {
        return assignment.assignmentEndDate !== null;
      })
      .sort((a, b) => {
        const dateA = a.assignmentEndDate ? timestampToDate(a.assignmentEndDate) : null;
        const dateB = b.assignmentEndDate ? timestampToDate(b.assignmentEndDate) : null;

        if (dateA === null && dateB === null) {
          return 0;
        } else if (dateA === null) {
          return -1;
        } else if (dateB === null) {
          return 1
        }

        return dateB.getTime() - dateA.getTime();
      });

    setTimeout(() => {
      this.showNoHistoryHint = true;
    }, 500);
    this.isLoading = false;
  }

  activated() {
    ToolbarContentModule.setToolbarTitle(this.title);
  }

  get title() {
    if (this.genericDevice) {
      return this.$t(
        `dryingHistory.dryingHistoryDevice`,
        [this.genericDevice.inventoryNumber]
      ).toString();
    }

    return "";
  }

  get deviceHistory() {
    return this.deviceAssignments;
  }

  calculateBackgroundStyle(programChainId: string) {
    return calculateBackgroundStyle(programChainId, StorageKeyLastVisitedItemLevel.LEVEL_4);
  }
}
